export default "__VITE_ASSET__8F1OtDtFq6dBtN6l2YS93w__"